export default __webpack_public_path__ + "static/media/Class_4_Mobile.790642d0.jpg";